// import generalConfig from '@/config'
const reportTableHeader = [
  {
    text: 'IO Number',
    value: 'ioNumbers'
  },
  {
    text: 'Campaign Name',
    value: 'name'
  },
  {
    text: 'Start Month',
    value: 'startDate'
  },
  {
    text: 'End Month',
    value: 'endDate'
  },
  {
    text: 'KPI Onboarded',
    value: 'onboardKPI'
  },
  {
    text: 'Target KPI Onboarded as at today',
    value: 'todayOnboardKPI'
  },
  {
    text: 'Actual Onboarded',
    value: 'actualOnboarded'
  },
  {
    text: 'Current Progress',
    value: 'currentProgress'
  },
  {
    text: 'Total Achieved',
    value: 'totalAchieved'
  },
  {
    text: 'KPI Converages',
    value: 'coverageKPI'
  },
  {
    text: 'Actual Coverages',
    value: 'coverageActual'
  },
  {
    text: 'Number of Reviewers',
    value: 'numberOfReviewers'
  },
  {
    text: '% Achieved',
    value: 'achieved'
  },
  {
    text: 'In Charge',
    value: 'inCharge'
  },
  {
    text: 'Actions',
    value: 'action',
    sortable: false
  }
]

const influencerHeaders = [
  {
    text: 'Influencer',
    value: 'handle'
  },
  {
    text: 'Followers',
    value: 'followers'
  },
  {
    text: 'Status',
    value: 'status'
  },
  {
    text: 'Completed Form',
    value: 'completedForm'
  },
  {
    text: 'Review in IMS',
    value: 'imsReview'
  },
  {
    text: 'Deliverables',
    value: 'deliverables'
  },
  {
    text: 'Number of Reviews',
    value: 'numberOfReviews'
  }
]

const defaultCalHeaders = [
  {
    text: 'POC',
    value: 'poc'
  },
  {
    text: 'Brand factSheet',
    value: 'bfs'
  },
  {
    text: 'Campaign',
    value: 'name'
  }
]

const overallTotals = {
  influencers: {
    title: 'Number of Influencers',
    value: 0
  },
  reviewers: {
    title: 'Number of Reviews',
    value: 0
  },
  followers: {
    title: 'Total Follower Count',
    value: 0
  }
}
const postedTotals = {
  reviewOutreach: {
    title: 'Total Review Outreach',
    value: 0
  },
  totalFollower: {
    title: 'Total Follower Count',
    value: 0
  },
  tiktokContents: {
    title: 'Number of Tiktok Content',
    value: 0
  },
  tiktokOutreach: {
    title: 'Tiktok Outreach',
    value: 0
  },
  instagramContent: {
    title: 'Number of Instagram Content',
    value: 0
  },
  instagramOutreach: {
    title: 'Instagram Outreach',
    value: 0
  }
}

const postedDeliverables = {
  IGS: {
    title: 'IGS',
    value: 0
  },
  IGV: {
    title: 'IGV',
    value: 0
  },
  IGR: {
    title: 'IGR',
    value: 0
  },
  IGC: {
    title: 'IGC',
    value: 0
  },
  IGP: {
    title: 'IGP',
    value: 0
  },
  TTP: {
    title: 'TTP',
    value: 0
  }
}
export default Object.assign({}, {
  reportTableHeader,
  influencerHeaders,
  defaultCalHeaders,
  overallTotals,
  postedTotals,
  postedDeliverables
})



// WEBPACK FOOTER //
// ./src/components/views/Campaign/AOKReport/config.js